import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthValue } from '../../lib/authSession';

const RUTAS_ADMIN = ['admin', 'gestor', 'profesional'];

const RutaProtegida = ({ children, authLoading = false, fallback = null }) => {
  if (authLoading) {
    return fallback;
  }

  const isAuthenticated = !!getAuthValue('auth');
  const userRol = getAuthValue('userRol');

  // Sin sesión → ir a la landing pública
  if (!isAuthenticated) {
    return <Navigate to="/inicio" replace />;
  }

  // Paciente/responsable no deben acceder al panel de staff → ir a su dashboard
  if (!RUTAS_ADMIN.includes(userRol || '')) {
    return <Navigate to="/inicio" replace />;
  }

  return children;
};

export default RutaProtegida;
